/**
 * Resolves a media URL — works for both:
 *  - Supabase Storage full URLs (https://xxx.supabase.co/storage/...)
 *  - Legacy local paths (/uploads/filename.jpg)
 */
const SERVER = process.env.REACT_APP_SERVER_URL || 'http://localhost:5001';

export function mediaUrl(url) {
  if (!url) return null;
  if (url.startsWith('http://') || url.startsWith('https://')) return url; // Supabase or any absolute URL
  return `${SERVER}${url}`; // legacy local upload
}
